import { DirectSubChannel, SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig } from "../types.js";

export const genericTotalizerClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    genericPulseTotalizer: {
        communicationMode: SensorPortCommunicationMode.DIRECT,
        requiredSubChannels: [DirectSubChannel.TOTAL],
        optionalSubChannels: [],
        isPermanentlyAttached: false,
        parameterConfigs: {},
        manufacturerName: "Unknown",
        modelName: "N/A",
        friendlyName: "Generic Pulse Totalizer",
        friendlyShortName: "Pulse Total",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "pulseTotalizer",
                parameters: {},
                legalConvertedRange: [0, null],
                subChannel: DirectSubChannel.TOTAL,
            },
        ],
        migrationProperties: {
            legacySensorType: "genericPulseTotalizer",
            legacyParametersToClusterParameters: () => ({}),
            clusterParametersToLegacyParameters: () => ({}),
        },
    },
};
